import {
  FontAwesomeIcon
} from "./chunk-APS5QAFW.js";
import {
  Button
} from "./chunk-JSCFMZUG.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Tag/Tag.tsx
import React, {
  forwardRef
} from "react";
import { Slot } from "@radix-ui/react-slot";
var colorStyles = {
  brand: {
    root: "text-picker-brand bg-picker-light-brand hover:bg-picker-medium-brand focus:bg-picker-medium-brand active:bg-picker-medium-brand"
  },
  grey: {
    root: "text-picker-grey bg-picker-light-grey hover:bg-picker-medium-grey focus:bg-picker-medium-grey active:bg-picker-medium-grey"
  },
  blue: {
    root: "text-picker-blue bg-picker-light-blue hover:bg-picker-medium-blue focus:bg-picker-medium-blue active:bg-picker-medium-blue"
  },
  orange: {
    root: "text-picker-orange bg-picker-light-orange hover:bg-picker-medium-orange focus:bg-picker-medium-orange active:bg-picker-medium-orange"
  },
  green: {
    root: "text-picker-green bg-picker-light-green hover:bg-picker-medium-green focus:bg-picker-medium-green active:bg-picker-medium-green"
  },
  red: {
    root: "text-picker-red bg-picker-light-red hover:bg-picker-medium-red focus:bg-picker-medium-red active:bg-picker-medium-red"
  },
  yellow: {
    root: "text-picker-yellow bg-picker-light-yellow hover:bg-picker-medium-yellow focus:bg-picker-medium-yellow active:bg-picker-medium-yellow"
  },
  pink: {
    root: "text-picker-pink bg-picker-light-pink hover:bg-picker-medium-pink focus:bg-picker-medium-pink active:bg-picker-medium-pink"
  },
  indigo: {
    root: "text-picker-indigo bg-picker-light-indigo hover:bg-picker-medium-indigo focus:bg-picker-medium-indigo active:bg-picker-medium-indigo"
  },
  violet: {
    root: "text-picker-violet bg-picker-light-violet hover:bg-picker-medium-violet focus:bg-picker-medium-violet active:bg-picker-medium-violet"
  }
};
var TAG_COLORS = Object.keys(colorStyles);
var tagStyles = twVariants({
  slots: {
    root: "flex w-fit items-center whitespace-nowrap rounded align-middle"
  },
  variants: {
    color: colorStyles,
    size: {
      sm: {
        root: "h-5 gap-1 px-2 font-body text-body-3 font-semibold [&_svg]:h-3 [&_svg]:w-3"
      },
      md: {
        root: "h-6 gap-2 px-2 py-0.5 font-body text-body-2 font-semibold [&_svg]:h-4 [&_svg]:w-4"
      }
    },
    disabled: {
      true: {
        root: "bg-neutral-disabled text-neutral-disabled"
      }
    },
    clickable: {
      true: {
        root: "cursor-pointer"
      },
      false: {
        root: "pointer-events-none cursor-default"
      }
    }
  }
});
var Tag = forwardRef(
  ({
    className,
    children,
    asChild = false,
    color = "grey",
    size = "md",
    disabled = false,
    selected = false,
    onClick,
    ...props
  }, ref) => {
    const clickable = !!onClick;
    const { root } = tagStyles({ color, size, disabled, clickable });
    const Comp = clickable ? Button : asChild ? Slot : "span";
    const selectableProps = clickable || selected ? {
      role: "checkbox",
      "aria-checked": selected,
      variant: "ghost",
      onClick,
      asChild
    } : {};
    return /* @__PURE__ */ React.createElement(
      Comp,
      {
        ref,
        className: cn(root(), className),
        ...props,
        ...selectableProps
      },
      children,
      selected && /* @__PURE__ */ React.createElement(FontAwesomeIcon, { name: "check:regular" })
    );
  }
);
Tag.displayName = "Tag";

export {
  TAG_COLORS,
  Tag
};
//# sourceMappingURL=chunk-R5TEDH6V.js.map